import imgix from "@lonelyplanet/dotcom-core/dist/helpers/imgix";
import hotelProvider from "./hotelProvider";
import resourceTypes from "../../../server/lib/open-planet/resourceTypes";

/**
 * Gets an image from a given resource
 * @param {any} resource An OP resource
 * @return {{ path?: string, orientation?: string }}
 */
export const getListImage = resource => {
  const isCollectionCard =
    resource.type === resourceTypes.collections && resource.newExperience;
  const isBookable =
    resource.type === resourceTypes.lodging ||
    resource.type === resourceTypes.partner_activity;

  if (resource.type === resourceTypes.availability) {
    return getListImage(resource.lodging);
  }

  if (
    resource.imageAssociations ||
    resource.images ||
    (resource.links && resource.links.image) ||
    resource.providers
  ) {
    let width;
    let height;
    if (isCollectionCard) {
      width = 300;
      height = 400;
    } else if (isBookable) {
      width = 128;
      height = 160;
    } else {
      width = 170;
      height = 106;
    }

    const imgixParams = {
      w: width,
      h: height,
      fit: "crop",
      q: 50,
      auto: "enhance",
      crop: "entropy",
    };

    const provider =
      resource.type === resourceTypes.lodging
        ? hotelProvider(resource.providers)
        : {
            type: "media",
          };

    let imagePath = "";

    if (resource.type === resourceTypes.partner_activity) {
      imagePath = imgix(resource.links.image, imgixParams, resource.provider);
    } else if (resource.type === resourceTypes.lodging) {
      if (Array.isArray(resource.images) && resource.images.length) {
        imagePath = imgix(
          resource.images[0].links.pixels,
          imgixParams,
          provider.type,
        );
      } else if (resource.images && typeof resource.images === "object") {
        imagePath = imgix(
          resource.images.links.pixels,
          imgixParams,
          provider.type,
        );
      } else {
        imagePath = "";
      }
    } else {
      const isAssociationsArray = Array.isArray(resource.imageAssociations);
      let fromImage;

      if (isAssociationsArray) {
        fromImage = resource.imageAssociations[0].from;
      } else if (resource.imageAssociations.tag !== "food") {
        fromImage = resource.imageAssociations.from;
      }

      if (fromImage) {
        imagePath = Array.isArray(fromImage)
          ? imgix(fromImage[0].links.pixels, imgixParams, provider.type)
          : imgix(fromImage.links.pixels, imgixParams, provider.type);
      }
    }

    return {
      path: `${imagePath}`,
      orientation: isBookable ? "portrait" : "landscape",
    };
  }

  return null;
};



// WEBPACK FOOTER //
// ./assets/shared/getListImage.js